import React from 'react';

import { KEYCHAIN } from '../../contexts/KeyMaster';
import { AuthorList, fetchMentionableEntities } from './AuthorList';
import SuggestionPortal, { createSuggestionRender } from './SuggestionPortal';

// `getChannelId` is a getter (not a raw value) so callers can hand in a ref-backed
// lookup. The tiptap editor is created once and holds this factory's return value
// in a closure for its lifetime — reading through a getter lets the channel scope
// update after mount without tearing down the editor.
export default function createProfileSuggestion({ getChannelId = () => null, getWorkspaceId = () => null } = {}) {
  const ProfileSuggestionPortal = ({ clientRect, onClose, ...listProps }) => (
    <SuggestionPortal clientRect={clientRect} onClose={onClose} keychainId={KEYCHAIN.POPOVER__PROFILE_SUGGESTION}>
      <AuthorList {...listProps} channelId={getChannelId()} />
    </SuggestionPortal>
  );

  return {
    char: '@',
    items: ({ query }) => fetchMentionableEntities(query, getChannelId(), getWorkspaceId()),

    allowSpaces: false,
    command: ({ editor, range, props }) => {
      const nodeAfter = editor.view.state.selection.$to.nodeAfter;
      const overrideSpace = nodeAfter?.text?.startsWith(' ');

      if (overrideSpace) range.to += 1;

      let nodeType = 'profile';
      let attrs = { id: props.id };

      if (props.entity_type === 'spammer') nodeType = 'spammer';

      editor
        .chain()
        .focus()
        .insertContentAt(range, [
          { type: nodeType, attrs },
          { type: 'text', text: ' ' },
        ])
        .run();

      editor.view.dom.ownerDocument.defaultView?.getSelection()?.collapseToEnd();
    },

    render: createSuggestionRender(ProfileSuggestionPortal),
  };
}
